import { eventsConstants } from '_store/_constants/events.constants';
import alertActions from '../alert.actions';
import eventsService from 'services/events.service';

export default function generateEventShareUrl(id) {
  return async dispatch => {
    dispatch(request());

    try {
      const response = await eventsService.generateEventShareUrl(id);
      dispatch(success(id, response.data));
      return response.data;
    } catch (error) {
      dispatch(failure(error));
      dispatch(alertActions.error('Erro ao gerar link compartilhável'));
      return null;
    }
  };

  function request() {
    return { type: eventsConstants.GENERATE_EVENT_SHARE_URL_REQUEST };
  }

  function success(id, data) {
    return {
      type: eventsConstants.GENERATE_EVENT_SHARE_URL_SUCCESS,
      id,
      shareUrl: data.share_url,
    };
  }

  function failure(error) {
    return { type: eventsConstants.GENERATE_EVENT_SHARE_URL_FAILURE, error };
  }
}
